export class ValidacniZprava {
	klic: string;
	hodnoty: any[];

	constructor(key: string, ...values: any[]) {
		this.klic = key;
		this.hodnoty = values;
	}
}
